import { Link, Typography } from '@mui/material';

const Copyright = (props) => {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      className={props?.styles['copyright-position']}
    >
      {`© ${new Date().getFullYear()} Sokoj - Ogranizacija muzičkih autora Srbije, izradio `}
      <Link color="inherit" href="http://dex.rs/sr/pocetna/" target="_blank">
        DEX d.o.o.
      </Link>
    </Typography>
  );
};

export default Copyright;
